import React from 'react'
import { IProps, SizeOptions, DefaultSizeOptions } from './index'
import getDefaultStyles from './styles'
import getLegacyStyles from './styles-legacy'
import { sanitizeReactChildren } from 'marketing-site/src/library/hooks/use-children-sanitizer/use-sanitizer'
import { BrandOptions, IBrand } from 'marketing-site/src/library/providers/brandProvider'

export const Text = React.memo(
  ({ size, children, brand = 'legacy' }: IProps): React.ReactElement => {
    const stylesToUse = getBrandedStyles(brand, size)
    children = sanitizeReactChildren(children)

    return (
      <span>
        <style jsx>{stylesToUse}</style>
        {children}
      </span>
    )
  },
)

export const BlockText = ({ size, children, brand = 'legacy' }: IProps): React.ReactElement => {
  const stylesToUse = getBrandedStyles(brand, size)
  children = sanitizeReactChildren(children)

  return (
    <div>
      <style jsx>{stylesToUse}</style>
      {children}
    </div>
  )
}

function getBrandedStyles(brand: IBrand, size: SizeOptions | DefaultSizeOptions) {
  if (brand === BrandOptions.default) {
    const defaultSize: DefaultSizeOptions = size as DefaultSizeOptions
    return getDefaultStyles(defaultSize)
  } else {
    const legacyStyles: SizeOptions = size as SizeOptions
    return getLegacyStyles(legacyStyles)
  }
}
